@import "../../../containers/styles.module.scss";

.regulationsForm {
  &__form {
    width: 309px;
    margin: 0 auto;
  }

  &__date {
    margin-left: -2rem !important;
  }
}
